import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientToken } from "../../../tokens";
import { CustomerActiveRewardsResponseSchema } from "../models/RewardsCustomerActiveRewardsSchemas";
import { CustomerDelayedRewardsResponseSchema } from "../models/RewardsCustomerDelayedRewardsSchemas";
import type {
    CustomerActiveRewardsResponseType,
    CustomerDelayedRewardsResponseType,
} from "../models/RewardsCustomerRewardsEntities";
import type { CustomerRewardsQueryParams } from "../types";

@singleton()
class RewardsCustomerRewardsApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public getCustomerActiveRewards(
        queryParams: CustomerRewardsQueryParams
    ): Observable<CustomerActiveRewardsResponseType> {
        return this.apiClient
            .get({
                url: "/general/getCustomerActiveRewards",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((response) =>
                    create(response.body, CustomerActiveRewardsResponseSchema)
                )
            );
    }

    public getCustomerDelayedRewards(
        queryParams: CustomerRewardsQueryParams
    ): Observable<CustomerDelayedRewardsResponseType> {
        return this.apiClient
            .get({
                url: "/general/getCustomerDelayedRewards",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((response) =>
                    create(response.body, CustomerDelayedRewardsResponseSchema)
                )
            );
    }
}

export default RewardsCustomerRewardsApiService;
